module.exports = __webpack_public_path__ + "a34573abc6c358d9905596be0c79733f.png";